import { useGameStore } from '../../store/GameStoreContext.ts';
import { ActionState, TurnState } from '@colonist/game-states';
import { ArrayUtils } from '@colonist/utils';
import { ActionsThatCanBeCancelled } from '@colonist/game-base-types';
import { useCurrentStateValidator } from '../../store/selectors/useCurrentStateValidator.ts';
export const ACTION_BUTTON_IDS = {
    passTurn: 'action-button-pass-turn',
    trade: 'action-button-trade',
    tradeBank: 'action-button-trade-bank',
    tradePlayers: 'action-button-trade-players',
    buildSettlement: 'action-button-build-settlement',
    buildCity: 'action-button-build-city',
    buildRoad: 'action-button-build-road',
    buyDevCard: 'action-button-buy-dev-card'
};
export const getHelperText = ({ isNotMyTurn, hasCurrentAction, isInitialPlacement, isDiceNotThrown })=>{
    if (isNotMyTurn) {
        return {
            key: 'strings:game.errors.notYourTurn'
        };
    }
    if (isInitialPlacement) {
        return {
            key: 'strings:game.errors.finishGameSetup'
        };
    }
    if (isDiceNotThrown) {
        return {
            key: 'strings:game.errors.rollDiceFirst'
        };
    }
    if (hasCurrentAction) {
        return {
            key: 'strings:game.errors.finishCurrentAction'
        };
    }
    return undefined;
};
export const useActionButtonCommonErrors = ()=>{
    const myColor = useGameStore((state)=>state.myColor);
    const currentState = useGameStore((state)=>state.gameState.currentState);
    const diceState = useGameStore((state)=>state.gameState.diceState);
    const currentStateValidator = useCurrentStateValidator();
    const actionState = currentStateValidator.getPlayerActionState(myColor);
    const isConfirmingAction = ArrayUtils.elementInArray(ActionsThatCanBeCancelled.actions, actionState);
    const isNotMyTurn = !currentStateValidator.currentTurnPlayers.includes(myColor);
    const hasCurrentAction = actionState != ActionState.None && !isConfirmingAction;
    const isInitialPlacement = currentState.turnState === TurnState.InitialPlacement;
    const isDiceNotThrown = !diceState.diceThrown;
    return {
        hasCommonErrors: isNotMyTurn || hasCurrentAction || isInitialPlacement || isDiceNotThrown,
        errorHelperText: getHelperText({
            isNotMyTurn: isNotMyTurn,
            hasCurrentAction: hasCurrentAction,
            isInitialPlacement: isInitialPlacement,
            isDiceNotThrown: isDiceNotThrown
        })
    };
};
